import React from "react";
import Helmet from "react-helmet";
import PropTypes from "prop-types";

const DocumentTitle = ({ title, ldJson, children }) => (
  <>
    <Helmet>
      <title>{title}</title>
      <script type="application/ld+json">
        {ldJson && JSON.stringify(ldJson)}
      </script>
    </Helmet>
    {children}
  </>
);

DocumentTitle.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default DocumentTitle;
